import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=1b1ba2a6&"
import script from "./AlertBox.vue?vue&type=script&lang=js&"
export * from "./AlertBox.vue?vue&type=script&lang=js&"
import style0 from "./AlertBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports